import { render, staticRenderFns } from "./RenewalInplayDetail.vue?vue&type=template&id=f6a57292&scoped=true"
import script from "./RenewalInplayDetail.vue?vue&type=script&lang=js"
export * from "./RenewalInplayDetail.vue?vue&type=script&lang=js"
import style0 from "./RenewalInplayDetail.vue?vue&type=style&index=0&id=f6a57292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a57292",
  null
  
)

export default component.exports